// gif-toggle.js
function isGifFile(src) {
  return src && src.match(/\.gif(\?|$)/i);
}

function enhanceGifImages(container) {
  let gifCounter = 0;
  container.querySelectorAll('img.theme-img, img.zoomImg').forEach(function (img) {
    const src = img.getAttribute('src');
    if (!isGifFile(src)) return;

    const gifSrc = src;
    const [baseUrl, queryString] = gifSrc.split('?');
    const jpgBaseUrl = baseUrl.replace(/\.gif$/i, '.jpg');
    const placeholderSrc = queryString ? `${jpgBaseUrl}?${queryString}` : jpgBaseUrl;

    const wrapper = document.createElement('div');
    const uniqueClass = `gif-wrapper-${gifCounter++}`;
    wrapper.className = `gif-wrapper ${uniqueClass}`;
    wrapper.dataset.wrapperId = uniqueClass;

    const newImg = img.cloneNode();
    newImg.src = placeholderSrc;
    newImg.dataset.gifSrc = gifSrc;
    newImg.dataset.placeholder = placeholderSrc;
    newImg.classList.add('gif-placeholder');

    if (img.hasAttribute('srcset')) {
      const originalSrcset = img.getAttribute('srcset');
      newImg.dataset.originalSrcset = originalSrcset;

      const jpgSrcset = originalSrcset
        .split(',')
        .map(item => {
          const [urlPart, size] = item.trim().split(' ');
          const [urlBase, urlQuery] = urlPart.split('?');
          const jpgUrlBase = urlBase.replace(/\.gif$/i, '.jpg');
          const newUrl = urlQuery ? `${jpgUrlBase}?${urlQuery}` : jpgUrlBase;
          return `${newUrl} ${size}`;
        })
        .join(', ');
      newImg.setAttribute('srcset', jpgSrcset);
      newImg.dataset.jpgSrcset = jpgSrcset;
    }

    const button = document.createElement('button');
    button.className = 'gif-toggle-btn';
    button.setAttribute('aria-label', 'Toggle animation');
    button.innerHTML = `
      <i class="play">
        <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
          <circle style="fill-opacity:0.1; stroke:#FFFFFF;stroke-width:2;" cx="20" cy="20" r="18.8"></circle>
          <path style="stroke:#FFFFFF;stroke-width:2;" fill="none"
                d="M29.8,19.9l-14.3,7.9c-0.3,0.2-0.7-0.1-0.7-0.4V11.6c0-0.4,0.4-0.6,0.7-0.4l14.3,7.9C30.1,19.3,30.1,19.8,29.8,19.9z"/>
        </svg>
      </i>
      <i class="pause" style="display: none;">
        <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
          <circle style="fill-opacity:0.1; stroke:#FFFFFF;stroke-width:2" cx="20" cy="20" r="18.9"></circle>
          <line style="stroke:#FFFFFF;stroke-width:2;" fill="none" x1="15.6" y1="11.3" x2="15.6" y2="28.7"></line>
          <line style="stroke:#FFFFFF;stroke-width:2;" fill="none" x1="24.4" y1="11.3" x2="24.4" y2="28.7"></line>
        </svg>
      </i>
    `;

    let playing = false;

    button.addEventListener('click', function (e) {
      e.preventDefault();
      playing = !playing;
      const wrapper = this.closest('.gif-wrapper');
      const newImg = wrapper.querySelector('img.gif-placeholder');
      newImg.src = playing ? gifSrc : placeholderSrc;

      if (newImg.hasAttribute('data-original-srcset')) {
        const original = newImg.dataset.originalSrcset;
        const jpgSrcset = original
          .split(',')
          .map(item => {
            const [urlPart, size] = item.trim().split(' ');
            const [urlBase, urlQuery] = urlPart.split('?');
            const jpgUrlBase = urlBase.replace(/\.gif$/i, '.jpg');
            const newUrl = urlQuery ? `${jpgUrlBase}?${urlQuery}` : jpgUrlBase;
            return `${newUrl} ${size}`;
          })
          .join(', ');
        newImg.setAttribute('srcset', playing ? original : jpgSrcset);
      }

      button.querySelector('.play').style.display = playing ? 'none' : '';
      button.querySelector('.pause').style.display = playing ? '' : 'none';
    });

    const parent = img.parentNode;
    if (parent) {
      parent.replaceChild(wrapper, img);
      wrapper.appendChild(newImg);
      wrapper.appendChild(button);
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  enhanceGifImages(document);
});
